import { Box, Paper, Skeleton, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { useNavigate, useParams } from 'react-router-dom';
import GoBackButtonIcon from '@/assets/icons/GoBackButtonIcon';

export default function OperatorFormSkeleton() {
  const navigate = useNavigate();
  const { operatorId } = useParams<{ operatorId: string }>();

  return (
    <Box>
      {/* Header */}
      <Box display='flex' alignItems='center' mb={3} gap={0.8}>
        <Box
          onClick={() => navigate(-1)}
          display='flex'
          alignItems='center'
          justifyContent='center'
          sx={{ cursor: 'pointer' }}
        >
          <GoBackButtonIcon />
        </Box>
        <Typography variant='h6' fontWeight={500}>
          {operatorId ? 'Edit Operator' : 'Add Operator'}
        </Typography>
      </Box>

      {/* Main Card */}
      <Paper
        elevation={0}
        sx={{
          backgroundColor: '#fff',
          borderRadius: '12px',
          p: 3,
          border: '1px solid #ECECEC'
        }}
      >
        <Grid container spacing={3}>
          {/* Name */}
          <Grid size={{ xs: 12, md: 6 }}>
            <Skeleton variant='text' width={60} height={20} sx={{ mb: 1 }} />
            <Skeleton variant='rectangular' height={56} sx={{ borderRadius: 1 }} />
          </Grid>

          {/* Email */}
          <Grid size={{ xs: 12, md: 6 }}>
            <Skeleton variant='text' width={60} height={20} sx={{ mb: 1 }} />
            <Skeleton variant='rectangular' height={56} sx={{ borderRadius: 1 }} />
          </Grid>

          {/* Phone */}
          <Grid size={{ xs: 12, md: 6 }}>
            <Skeleton variant='text' width={100} height={20} sx={{ mb: 1 }} />
            <Skeleton variant='rectangular' height={56} sx={{ borderRadius: 1 }} />
          </Grid>
        </Grid>

        {/* Schedule Skeleton */}
        <Box mt={4}>
          <Skeleton variant='text' width={100} height={24} sx={{ mb: 2 }} />

          {Array.from({ length: 6 }).map((_, index) => (
            <Box
              key={index}
              display='flex'
              alignItems='center'
              justifyContent='space-between'
              py={1.2}
              borderBottom='1px solid #F1F1F1'
            >
              <Skeleton width={80} height={20} />
              <Skeleton width={60} height={24} />
              <Skeleton width={180} height={40} sx={{ borderRadius: 1 }} />
              <Skeleton width={100} height={36} sx={{ borderRadius: 18 }} />
            </Box>
          ))}
        </Box>
      </Paper>

      {/* Footer */}
      <Box display='flex' justifyContent='end' gap={1} mt={3}>
        <Skeleton variant='rectangular' width={90} height={40} sx={{ borderRadius: 1 }} />
        <Skeleton variant='rectangular' width={120} height={40} sx={{ borderRadius: 1 }} />
      </Box>
    </Box>
  );
}
